<template>
  <div class="container-fluid">
    <bread-crumb :bread_crumb_data="view.bread_crumb_data">
      <template #suffix>
        <b-button variant="success" @click="openThreePeriodModal()">三期續繳總表</b-button>
      </template>
    </bread-crumb>

    <ul>
      <li v-for="(item, index) in data.table_fields" :key="index">
        <div class="sales-item">
          <div :class="['fields', item.bgFieldColor]">{{ item.label }}</div>

          <div class="data">
            <template v-if="item.key === 'direct_push_contract'">
              {{ convertRocDate(data.table_data.new_member_join_date) }} {{ data.table_data.new_member_number }} {{ data.table_data.new_member_name }}
            </template>

            <template v-else-if="item.key === 'direct_push_return_piece'">
              {{ convertRocDate(data.table_data.new_return_member_join_date) }}
              {{ data.table_data.new_return_member_number }}
              {{ data.table_data.new_return_member_name }}
              （直推業務員：{{ data.table_data.new_return_member_sales_number }}{{ data.table_data.new_return_member_sales_name}}）
            </template>

            <template v-else-if="item.key === 'birthday'">
              {{ convertRocDate(data.table_data.birthday) }}
            </template>

            <template v-else-if="item.key === 'bank'">
              {{ data.table_data.bank }}({{ data.table_data.branch }}) 戶名：{{ data.table_data.bank_name }} 帳號：{{ data.table_data.bank_account }}
            </template>

            <template v-else-if="item.key === 'upper_sale'">
              {{ data.table_data.upper_number }}{{ data.table_data.upper_name }}
            </template>

            <template v-else>
              {{ data.table_data[item.key] }}
            </template>
          </div>
        </div>
      </li>
    </ul>

     <!-- 直推三期續繳總表 modal -->
    <three-period-bill-modal
      v-model="status.threePeriodBillModal"
      :data="data.temp_table_data" />
  </div>
</template>

<script>
import BreadCrumb from '@/components/layouts/BreadCrumb';
import businessInfoApi from "@/models/API/businessInfoApi";
import { convertRocDate, getLocalUserInfo, getTodayDate, getFirstAndLastDayOfMonth } from "@/models/HELPERS/common.js";
import ThreePeriodBillModal from "@/components/common/Modal/ThreePeriodBillModal";

export default {
  name: 'information',
  components: {
    BreadCrumb,
    ThreePeriodBillModal
  },
  data () {
    return {
      view: {
        bread_crumb_data: [
          { name: '業務資料', url: '', isActive: true },
          { name: '個人訊息', url: '', isActive: false }
        ]
      },
      search: {
        number: '',
        name: '',
      },
      status: {
        threePeriodBillModal: false,
      },
      data: {
        table_data: {},
        table_fields: [
          {
            key: "direct_push_contract",
            label: "自己最新直推契約",
            bgFieldColor: "red"
          },
          {
            key: "direct_push_return_piece",
            label: "直推最新回歸契約",
            bgFieldColor: "yellow"
          },
          {
            key: "number",
            label: "業務編號",
            bgFieldColor: "grey"
          },
          {
            key: "name",
            label: "業務姓名",
            bgFieldColor: "grey"
          },
          {
            key: "birthday",
            label: "業務生日",
            bgFieldColor: "grey"
          },
          {
            key: "phone",
            label: "業務電話",
            bgFieldColor: "grey"
          },
          {
            key: "cellphone",
            label: "業務手機",
            bgFieldColor: "grey"
          },
          {
            key: "address",
            label: "通訊地址",
            bgFieldColor: "grey"
          },
          {
            key: "bank",
            label: "銀行資料",
            bgFieldColor: "grey"
          },
          {
            key: "upper_sale",
            label: "上層業務",
            bgFieldColor: "grey"
          },
          {
            key: "rank",
            label: "目前聘階",
            bgFieldColor: "grey"
          },
          {
            key: "valid_count",
            label: "有效會員數",
            bgFieldColor: "grey"
          },
          // {
          //   key: "",
          //   label: "未領件數",
          //   bgFieldColor: "grey"
          // }
        ],
        info: {},
        temp_table_data: {}
      }
    }
  },
  mounted() {
    this.businessInfoApi = new businessInfoApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      const meta = this.$route.meta;
      this.data.info = getLocalUserInfo(meta.authority);
      this.getBusinessPersonalInfo();
    },
    convertRocDate,
    // 查詢要助人個人資訊
    getBusinessPersonalInfo() {
      const params = {
        'ID_number': this.data.info.account,
      };
      this.businessInfoApi.getBusinessPersonalInfo((response) => {
        const res = response.data;

        this.data.table_data = res.data[res.data.length - 1];
      }, params)
    },
    // 開啟直推三期續繳總表modal
    openThreePeriodModal() {
      this.status.threePeriodBillModal = true;

      const params = {
        class_detail: 1,
        sales_name: this.data.table_data.name,
        sales_number: this.data.table_data.number,
        member_status: 0,
        dead_date_S: this.getDateRange(false).date_start,
        dead_date_E: this.getDateRange(false).date_end
      };

      this.data.temp_table_data = Object.assign({}, params);
    },
    // 取得日期範圍
    getDateRange(is_special_mode = true) {
      const [year, month, day] = getTodayDate().split('-').map(Number);
      const today_start = new Date(), today_end = new Date();

      let date_start, date_end;

      // 如現在是8月，則日期為10號以前，顯示567月;反之顯示678月
      if (day <= 10 && is_special_mode) {
        today_start.setMonth(today_start.getMonth() - 3)
        date_start = getFirstAndLastDayOfMonth(today_start).first_day;

        today_end.setMonth(today_end.getMonth())
        date_end = getFirstAndLastDayOfMonth(today_end).first_day;
      } else {
        today_start.setMonth(today_start.getMonth() - 2)
        date_start = getFirstAndLastDayOfMonth(today_start).first_day;

        today_end.setMonth(today_end.getMonth() + 1)
        date_end = getFirstAndLastDayOfMonth(today_end).first_day;
      }

      return { date_start, date_end };
    },
  }
}
</script>

<style lang="scss" scoped>
  ul {
    font-size: 18px;
    padding-left: 0;
    li {
      list-style: none;
      .sales-item {
        display: flex;
        .fields {
          padding: 5px;
          width: 160px;
          &.blue {
            color: #FFFFFF;
            background: blue;
          }
          &.red {
            color: #FFFFFF;
            background: red;
          }
          &.yellow {
            color: #A52A2A;
            background: yellow;
          }
          &.grey {
            background: #C0C0C0;
          }
        }
        .data {
          padding: 5px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Backstage/businessInfo/information.vue